import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { IContextMenuAction } from './context-menu-action.interface';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContextMenuComponent implements OnInit {
  @Input() menuId: string;
  @Input() actions: IContextMenuAction[] = [];
  @Input() zIndex = 100;
  @Input() direction: "up" | "down" = "down";

  @Output() onAction = new EventEmitter<IContextMenuAction>();

  private isClosing = false;

  constructor() { }

  private get menu() {
    const menu: HTMLElement = document.getElementById(this.menuId);
    return menu;
  }

  get buttonsEnabled() {
    return !this.isClosing;
  }

  get visibleActions() {
    return this.actions.filter(m => !m.showIf || m.showIf());
  }

  ngOnInit(): void {
  }

  isEnabled(action: IContextMenuAction): boolean {
    return this.buttonsEnabled && (!action.enableIf || action.enableIf());
  }

  buttonClick(action: IContextMenuAction): void {
    if (!this.isEnabled(action)) {
      return;
    }

    this.onAction.emit(action);

    if (action.action) {
      action.action();
    }

    this.close();
  }

  show(x: number, y: number) {
    this.isClosing = false;
    this.menu.style.position = "fixed";
    this.menu.style.display = "block";
    this.menu.style.zIndex = "" + (this.zIndex + 1);
    this.menu.style.top = y + "px";
    this.menu.style.left = x + "px";
    AnimationHelper.animate(this.menu, "fadeIn");
  }

  close(): void {
    // this.isClosing = true;
    // AnimationHelper.animate(this.menu, "fadeOut").finally(() => {
    this.menu.style.display = "none";
    // this.isClosing = false;
    // });
  }
}
